import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { breakpoints } from '@chegg-ui/theme';
import { Popover } from '@chegg-ui/popover';
import { NavigationDataType, useNavigationData } from '@chegg-me-components/navigation-data';
import { getRioClient, initializeRioClient, nextCookies } from '@chegg-me-components/utils';
import Media from 'react-media';
import { rioLoggingForLanguageSelected, rioLoggingForOpeningSelector, updateRIOClientState } from '../rioLogging';
import { getCookieLangIndex, getDefaultLangIndex, saveLanguageCookie, useListboxBehaviour } from '../shared';
import { LanguageSelectorIcon } from '../shared/LanguageSelectorIcon';
import { LangSelectorWrapper, StyledListbox } from '../styles';
export var rioClient = getRioClient();

var LanguageSelector = function LanguageSelector(_ref) {
  var languageProps = _ref.languageProps,
      clientEnv = _ref.clientEnv,
      _ref$isFooter = _ref.isFooter,
      isFooter = _ref$isFooter === void 0 ? false : _ref$isFooter,
      _ref$dataTest = _ref.dataTest,
      dataTest = _ref$dataTest === void 0 ? 'selector' : _ref$dataTest,
      _ref$defaultLocale = _ref.defaultLocale,
      defaultLocale = _ref$defaultLocale === void 0 ? 'en-US' : _ref$defaultLocale,
      rioConfig = _ref.rioConfig,
      cookieDomain = _ref.cookieDomain,
      _ref$signedIn = _ref.signedIn,
      signedIn = _ref$signedIn === void 0 ? false : _ref$signedIn,
      oneGraphClient = _ref.oneGraphClient;
  var listBoxRef = useRef(null);
  var skipQuery = languageProps.length > 0;

  var _useNavigationData = useNavigationData({
    skipQuery: skipQuery,
    navigationDataType: NavigationDataType.LanguageSelector,
    clientEnv: clientEnv,
    useCache: false,
    // isPreviewMode,
    // accessToken,
    oneGraphClient: oneGraphClient
  }),
      _useNavigationData$da = _useNavigationData.data,
      data = _useNavigationData$da === void 0 ? {
    children: [{
      language: '',
      langCode: '',
      langLocale: ''
    }]
  } : _useNavigationData$da;

  var selectorData = skipQuery ? languageProps : data.children;
  var cookies = nextCookies().get();
  var options = selectorData.map(function (lang) {
    return lang.language;
  }).filter(function (option) {
    return option;
  }); // Finds if langPreference cookie is present. Returns -1 if not found.

  var cookieLangIndex = getCookieLangIndex(selectorData, cookies); // Finds the index of the locale passed as defaultLocale to the LanguageSelector package

  var defaultLocaleIndex = getDefaultLangIndex(selectorData, defaultLocale); // If locale from cookie dosen't match availabe locales, use the default locale .

  var activeIndex = cookieLangIndex === -1 ? Math.max(defaultLocaleIndex, 0) : cookieLangIndex;

  var _useState = useState(activeIndex),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  useEffect(function () {
    // Initialize Rio Client
    if (rioConfig) {
      initializeRioClient(rioConfig);
    }

    updateRIOClientState(signedIn);
  }, []);

  var onLanguageSelect = function onLanguageSelect(e) {
    setSelectedIndex(e);
    selectedIndex !== e && saveLanguageCookie(selectorData[e].langLocale, cookieDomain);
    rioLoggingForLanguageSelected(selectorData, e);
  };

  var _useListboxBehaviour = useListboxBehaviour(options, onLanguageSelect),
      pseudoFocusedListboxIndex = _useListboxBehaviour.pseudoFocusedListboxIndex,
      onListboxKeyDown = _useListboxBehaviour.onListboxKeyDown;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Media, {
    query: {
      maxWidth: breakpoints.md.max
    }
  }, function (matches) {
    var _selectorData$selecte;

    return /*#__PURE__*/React.createElement(Popover, {
      targetElement: /*#__PURE__*/React.createElement(LangSelectorWrapper, null, /*#__PURE__*/React.createElement(LanguageSelectorIcon, {
        langCode: (_selectorData$selecte = selectorData[selectedIndex]) === null || _selectorData$selecte === void 0 ? void 0 : _selectorData$selecte.langCode,
        signedIn: signedIn
      })),
      "data-test": dataTest,
      width: !isFooter ? '280px' : '230px',
      showBeak: !isFooter,
      position: !isFooter ? 'bottomLeft' : matches ? 'top' : 'topLeft',
      onPopoverStateChange: function onPopoverStateChange(isOpen) {
        isOpen && rioLoggingForOpeningSelector(selectorData);

        if (listBoxRef.current) {
          listBoxRef.current.focus();
        }
      }
    }, /*#__PURE__*/React.createElement(StyledListbox, {
      ref: listBoxRef,
      inputId: dataTest,
      options: options,
      isOpen: true,
      pseudoFocusedIndex: pseudoFocusedListboxIndex,
      selectedIndex: selectedIndex,
      onSelectOption: onLanguageSelect,
      showCheckIcon: true,
      onKeyDown: onListboxKeyDown,
      tabIndex: -1
    }));
  }));
};

LanguageSelector.displayName = 'LanguageSelector';
export default LanguageSelector;